import { registerVueWidgetForJsp } from "@/Registry";

registerVueWidgetForJsp("ActionableReflectSection", async () => 
   (await import("./widgets/ActionableReflectSection")).ActionableReflectSectionWidget
);

registerVueWidgetForJsp("ActionableActionbar", async () => 
   (await import("./widgets/ActionableActionbar")).ActionableActionbarWidget
);

registerVueWidgetForJsp("FullSearch", async () => 
   (await import("./widgets/FullSearch")).FullSearchWidget
);

registerVueWidgetForJsp("AskGetabstractWidget", async () => 
   (await import("./widgets/AskGetabstractWidget")).AskGetabstractWidgetWidget
);

registerVueWidgetForJsp("AskGetabstractIframe", async () => 
   (await import("./widgets/AskGetabstractIframe")).AskGetabstractIframeWidget
);

registerVueWidgetForJsp("AskGetabstractDemo", async () => 
   (await import("./widgets/AskGetabstractDemo")).AskGetabstractDemoWidget
);

registerVueWidgetForJsp("OnlineContentNavigation", async () => 
   (await import("./widgets/OnlineContentNavigation")).OnlineContentNavigationWidget
);

registerVueWidgetForJsp("GaTopLayer", async () => 
   (await import("./widgets/GaTopLayer")).GaTopLayerWidget
);

registerVueWidgetForJsp("GaNotificationLayer", async () => 
   (await import("./widgets/GaNotificationLayer")).GaNotificationLayerWidget
);

registerVueWidgetForJsp("ModalDemo", async () => 
   (await import("./widgets/ModalDemo")).ModalDemoWidget
);

registerVueWidgetForJsp("ExperimentalGeneratorDemo", async () => 
   (await import("./widgets/ExperimentalGeneratorDemo")).ExperimentalGeneratorDemoWidget
);

registerVueWidgetForJsp("GaProgressCircleDemo", async () => 
   (await import("./widgets/GaProgressCircleDemo")).GaProgressCircleDemoWidget
);

registerVueWidgetForJsp("SummaryCardDefaultDemo", async () => 
   (await import("./widgets/SummaryCardDefaultDemo")).SummaryCardDefaultDemoWidget
);

registerVueWidgetForJsp("SummaryCardCompactDemo", async () => 
   (await import("./widgets/SummaryCardCompactDemo")).SummaryCardCompactDemoWidget
);

registerVueWidgetForJsp("SummaryCardMiniDemo", async () => 
   (await import("./widgets/SummaryCardMiniDemo")).SummaryCardMiniDemoWidget
);

registerVueWidgetForJsp("FullSearchAiDemoComponent", async () => 
   (await import("./widgets/FullSearchAiDemoComponent")).FullSearchAiDemoComponentWidget
);

registerVueWidgetForJsp("MIABPage", async () => 
   (await import("./widgets/MIABPage")).MIABPageWidget
);

registerVueWidgetForJsp("BadgeDemo", async () => 
   (await import("./widgets/BadgeDemo")).BadgeDemoWidget
);

registerVueWidgetForJsp("GaFeedbackDemo", async () => 
   (await import("./widgets/GaFeedbackDemo")).GaFeedbackDemoWidget
);

registerVueWidgetForJsp("MIABOverviewPage", async () => 
   (await import("./widgets/MIABOverviewPage")).MIABOverviewPageWidget
);

registerVueWidgetForJsp("OfferExpenseTool", async () => 
   (await import("./widgets/OfferExpenseTool")).OfferExpenseToolWidget
);

registerVueWidgetForJsp("OfferForm", async () => 
   (await import("./widgets/OfferForm")).OfferFormWidget
);

registerVueWidgetForJsp("ContentCardDemo", async () => 
   (await import("./widgets/ContentCardDemo")).ContentCardDemoWidget
);

registerVueWidgetForJsp("GaDesignSpa", async () => 
   (await import("./widgets/GaDesignSpa")).GaDesignSpaWidget
);

registerVueWidgetForJsp("GaDesignSpaWebApp", async () => 
   (await import("./widgets/GaDesignSpaWebApp")).GaDesignSpaWebAppWidget
);

registerVueWidgetForJsp("DateFormattingDemo", async () => 
   (await import("./widgets/DateFormattingDemo")).DateFormattingDemoWidget
);

registerVueWidgetForJsp("LeadFormWidget", async () => 
   (await import("./widgets/LeadFormWidget")).LeadFormWidgetWidget
);

registerVueWidgetForJsp("LeadFormWidgetGraphConnector", async () => 
   (await import("./widgets/LeadFormWidgetGraphConnector")).LeadFormWidgetGraphConnectorWidget
);

registerVueWidgetForJsp("ExpertVideoOverviewPage", async () => 
   (await import("./widgets/ExpertVideoOverviewPage")).ExpertVideoOverviewPageWidget
);

registerVueWidgetForJsp("ExpertVideoDetailPage", async () => 
   (await import("./widgets/ExpertVideoDetailPage")).ExpertVideoDetailPageWidget
);

registerVueWidgetForJsp("AiSolutionsForm", async () => 
   (await import("./widgets/AiSolutionsForm")).AiSolutionsFormWidget
);

registerVueWidgetForJsp("QuickWinDemo", async () => 
   (await import("./widgets/QuickWinDemo")).QuickWinDemoWidget
);

registerVueWidgetForJsp("GrowthDashboardWidget", async () => 
   (await import("./widgets/GrowthDashboardWidget")).GrowthDashboardWidgetWidget
);

registerVueWidgetForJsp("ApiDoc", async () => 
   (await import("./widgets/ApiDoc")).ApiDocWidget
);

registerVueWidgetForJsp("GaPopoverDemo", async () => 
   (await import("./widgets/GaPopoverDemo")).GaPopoverDemoWidget
);

registerVueWidgetForJsp("PortletContainerItemWidget", async () => 
   (await import("./widgets/PortletContainerItemWidget")).PortletContainerItemWidgetWidget
);

registerVueWidgetForJsp("DemoNotification", async () => 
   (await import("./widgets/DemoNotification")).DemoNotificationWidget
);

registerVueWidgetForJsp("CopilotSetupPage", async () => 
   (await import("./widgets/CopilotSetupPage")).CopilotSetupPageWidget
);

registerVueWidgetForJsp("DemoActionables", async () => 
   (await import("./widgets/DemoActionables")).DemoActionablesWidget
);

registerVueWidgetForJsp("DemoTooltip", async () => 
   (await import("./widgets/DemoTooltip")).DemoTooltipWidget
);

registerVueWidgetForJsp("DemoButton", async () => 
   (await import("./widgets/DemoButton")).DemoButtonWidget
);

registerVueWidgetForJsp("DemoTable", async () => 
   (await import("./widgets/DemoTable")).DemoTableWidget
);

registerVueWidgetForJsp("DemoSummaries", async () => 
   (await import("./widgets/DemoSummaries")).DemoSummariesWidget
);

registerVueWidgetForJsp("DemoIcons", async () => 
   (await import("./widgets/DemoIcons")).DemoIconsWidget
);

registerVueWidgetForJsp("DemoChannels", async () => 
   (await import("./widgets/DemoChannels")).DemoChannelsWidget
);

registerVueWidgetForJsp("TrialDialog", async () => 
   (await import("./widgets/TrialDialog")).TrialDialogWidget
);

registerVueWidgetForJsp("LoginTotp", async () => 
   (await import("./widgets/LoginTotp")).LoginTotpWidget
);

